export enum FileUploadTypes {
  Encounters = 'encounters',
  Combined = 'combined',
  Labs = 'labs',
}
